import { isDefined } from '@repo/toolkit/is-defined'

import { ReportStatusEnum } from '../../../lib/types/enums/affected-staff/report-status.enum'
import { CurrencyEnum } from '../../../lib/types/enums/common/currency.enum'
import { AffectedStaff } from '../../../lib/types/models/affectedStaff/affected-staff'
import { AffectedStaffInput } from '../../../lib/types/models/affectedStaff/affected-staff-input'

type AffectedStaffMapExtraAttributes = {
  participatedInRad?: boolean
}

export const mapAffectedStaffToAffectedStaffInput = (
  affectedStaff: AffectedStaff,
  { participatedInRad }: AffectedStaffMapExtraAttributes
): AffectedStaffInput => {
  return {
    ...(affectedStaff.tripId && { tripId: affectedStaff.tripId }),
    endOfStayReportValidatedAt: affectedStaff.endOfStayReportValidatedAt,
    sentEndOfStayReport: affectedStaff.endOfStayReportStatus === ReportStatusEnum.VALIDATED,
    associatedRadId: affectedStaff.associatedRadId,
    appointmentTime: affectedStaff.appointmentTime,
    currency: affectedStaff.currency ?? CurrencyEnum.EUR,
    baseSalary: affectedStaff.baseSalary,
    exceptionalBonusAmount: affectedStaff.exceptionalBonusAmount,
    exceptionalBonusReason: affectedStaff.exceptionalBonusReason,
    startDate: affectedStaff.startDate,
    endDate: affectedStaff.endDate,
    travelChoice: affectedStaff.travelChoice,
    expenseIncludeHotelBooking: affectedStaff.expenseIncludeHotelBooking,
    ...(isDefined(participatedInRad)
      ? { participatedInRad: participatedInRad }
      : { participatedInRad: true }),
    ...(affectedStaff.facNumber && { facNumber: affectedStaff.facNumber }),
    ...(affectedStaff.rating && { rating: affectedStaff.rating }),
    ...(affectedStaff.comment && { comment: affectedStaff.comment })
  }
}
